/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Docx_ExportedInputs */

const en_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX exported`)
};

const de_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX exportiert`)
};

const fr_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX exporté`)
};

const es_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX exportado`)
};

const it_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX esportato`)
};

const nl_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX geexporteerd`)
};

const pl_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX wyeksportowany`)
};

const fi_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX viety`)
};

const da_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX eksporteret`)
};

const sv_resumes_docx_exported = /** @type {(inputs: Resumes_Docx_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX exporterat`)
};

/**
* | output |
* | --- |
* | "DOCX exported" |
*
* @param {Resumes_Docx_ExportedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_docx_exported = /** @type {((inputs?: Resumes_Docx_ExportedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Docx_ExportedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_docx_exported(inputs)
	if (locale === "fr") return fr_resumes_docx_exported(inputs)
	if (locale === "es") return es_resumes_docx_exported(inputs)
	if (locale === "it") return it_resumes_docx_exported(inputs)
	if (locale === "nl") return nl_resumes_docx_exported(inputs)
	if (locale === "pl") return pl_resumes_docx_exported(inputs)
	if (locale === "fi") return fi_resumes_docx_exported(inputs)
	if (locale === "da") return da_resumes_docx_exported(inputs)
	if (locale === "sv") return sv_resumes_docx_exported(inputs)
	return en_resumes_docx_exported(inputs)
});